import { TabListActions } from "../types";
const { UPDATE_INDEX } = TabListActions;

export const updateIndex = payload => ({
  type: UPDATE_INDEX,
  payload
});
